import { Directive, Input, HostListener } from '@angular/core';

@Directive({
    selector: '[limit-to]',
})
export class LimitToDirective {

    @Input('limit-to') limitTo: number;

    constructor( ) { }

    @HostListener('keypress', ['$event'])
    onKeyPress(e: any) {

        if (this.limitTo && this.limitTo > 0) {
            e.target.value.length >= this.limitTo ? e.preventDefault() : null;
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(e: any) {

        let data = String(e.clipboardData.getData('text/plain'));

        if (this.limitTo && this.limitTo > 0) {
            if ((e.target.value + data).length > this.limitTo) {
                e.preventDefault();
                return e.target.value = (e.target.value + data).substring(0, this.limitTo);
            } else {
                return e.target.value;
            }
        }
    }
}